import { render } from "./CatalogsSettings.vue?vue&type=template&id=694da4b7&ts=true"
import script from "./CatalogsSettings.vue?vue&type=script&lang=ts"
export * from "./CatalogsSettings.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__